const indicatorEnumerators = {
  periodicity: [
    'daily',
    'weekly',
    'monthly',
    'yearly',
    'dateTimeRange',
  ],
  entityType: [
    'location',
    'asset',
    'appUser',
    'formCategory',
    'formTemplate',
    'wasteType',
  ],
  quantityUnit: [
    'kg',
    'liters',
    'percent',
    'ton',
    'm3',
    'm2',
    'm',
    'cm',
    'mm',
  ],
  indicator: [
    'rejections',
    'validated',
    'findings',
    'withdrawals',
    'ingress',
    'egress',
  ],
  wasteType: [
    'Botellas Plásticas',
    'Carcasas Mantención',
    'Cartón',
    'Chatarra',
    'Correas Transportadoras',
    'EPP',
    'EPP Duro',
    'EPP Textil',
    'Escombros',
    'Filtros de Aire',
    'Gomas',
    'Gomas (botas;pecheras;guantes de goma)',
    'HDPE',
    'HDPE Carpeta',
    'HDPE Despunte',
    'HDPE Líneas',
    'HDPE Viruta',
    'Madera Internacional',
    'Madera Nacional',
    'Manteletas',
    'Maxi-Sacos',
    'Neumáticos',
    'Plástico blando',
    'Plástico Industrial',
    'Plástico Industrial Duro',
    'Tambores Vacíos',
  ],
};

export default indicatorEnumerators;
